import { useParams } from 'react-router-dom'

export const useSiteId = (): number => {
  const { siteId } = useParams()
  return Number(siteId)
}
